import { render } from "./BrandListTableHeader.vue?vue&type=template&id=89eaff5a"
import script from "./BrandListTableHeader.vue?vue&type=script&lang=js"
export * from "./BrandListTableHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__